export const ChevronUpIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Collapse",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="chevron-up-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <title>{title}</title>
      <path
        d="M17 15L12 10L7 15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
